import { ICON_TYPES } from '../constants';

export const CallIcon = ({
  fill = 'none',
  width = '14',
  height = '14',
}): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.28345 9.48558C6.58501 8.76644 5.23439 7.41269 4.5192 5.71258L6.50253 3.72575L2.85086 0.0711667L1.00111 1.92033C0.680281 2.243 0.426616 2.62609 0.254797 3.04742C0.0829773 3.46876 -0.00358646 3.91999 0.000113809 4.375C0.000113809 8.603 5.39711 14 9.62511 14C10.0801 14.004 10.5313 13.9175 10.9526 13.7457C11.3739 13.5739 11.7568 13.3201 12.0792 12.999L13.9289 11.1493L10.2744 7.49467L8.28345 9.48558ZM11.2538 12.1742C11.0396 12.3865 10.7853 12.5542 10.5056 12.6673C10.226 12.7805 9.92673 12.8369 9.62511 12.8333C5.9892 12.8333 1.16678 8.01092 1.16678 4.375C1.16335 4.07332 1.21984 3.77396 1.333 3.49428C1.44615 3.2146 1.61371 2.96017 1.82595 2.74575L2.85086 1.72083L4.85578 3.72575L3.1437 5.43783L3.28661 5.796C3.70734 6.92143 4.36506 7.94328 5.2152 8.79232C6.06535 9.64136 7.08805 10.2977 8.21403 10.717L8.56753 10.8518L10.2744 9.14433L12.2793 11.1493L11.2538 12.1742ZM8.16678 1.16667V0C9.71336 0.00169843 11.1961 0.616825 12.2897 1.71042C13.3833 2.80401 13.9984 4.28676 14.0001 5.83333H12.8334C12.8321 4.59608 12.3399 3.40991 11.4651 2.53504C10.5902 1.66017 9.40403 1.16806 8.16678 1.16667ZM8.16678 3.5V2.33333C9.09475 2.33426 9.98445 2.70331 10.6406 3.35948C11.2968 4.01566 11.6659 4.90536 11.6668 5.83333H10.5001C10.5001 5.2145 10.2543 4.621 9.8167 4.18342C9.37911 3.74583 8.78562 3.5 8.16678 3.5Z"
        fill={fill}
      />
    </svg>
  );
};

CallIcon.iconType = ICON_TYPES.CALL;
